import { useEffect, useState } from 'react';
import Error from 'src/components/app/Error';
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Tooltip,
} from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CodeIcon from '@mui/icons-material/Code';
import CodeOffIcon from '@mui/icons-material/CodeOff';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmDialog from 'src/components/confirmDialog/ConfirmDialog';
import { useSnackbar } from 'notistack';
import $api from '../http';

const ShopifyList = () => {
  const [loadError, setLoadError] = useState(false);
  const [items, setItems] = useState([]);
  const [disconnectDialogOpen, setDisconnectDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [currentItemId, setCurrentItemId] = useState();
  const { enqueueSnackbar } = useSnackbar();

  const loadContent = () => {
    $api.get('/shopify')
      .catch((err) => {
        setLoadError(err);
        return null;
      })
      .then((response) => {
        if (response && response.data) {
          setItems(response.data);
        }
      });
  };

  const handleDisconnect = (id) => {
    setCurrentItemId(id.toString());
    setDisconnectDialogOpen(true);
  };

  const handleDelete = (id) => {
    setCurrentItemId(id.toString());
    setDeleteDialogOpen(true);
  };

  const handleConnect = (id) => {
    $api.post('/shopify/connect', {
      id
    })
      .catch(() => {
        enqueueSnackbar('Error connecting widget', {
          variant: 'error'
        });
        return null;
      })
      .then((res) => {
        if (res !== null) {
          enqueueSnackbar('Widget connected', {
            variant: 'success'
          });
          loadContent();
        }
      });
  };

  useEffect(() => {
    loadContent();
  }, []);

  const handleDisconnectDialogSubmit = () => {
    loadContent();
    setDisconnectDialogOpen(false);
    enqueueSnackbar('Widget disconnected', {
      variant: 'success'
    });
  };

  const handleDeleteDialogSubmit = () => {
    loadContent();
    setDeleteDialogOpen(false);
    enqueueSnackbar('Widget deleted', {
      variant: 'success'
    });
  };

  if (loadError && Object.keys(loadError).length !== 0) {
    return (
      <Error error={loadError} />
    );
  }

  return (
    <>
      <ConfirmDialog
        title="Disconnect widget"
        content="Do you want to disconnect widget from Shopify?"
        actionUrl="/shopify/disconnect"
        open={disconnectDialogOpen}
        onSubmit={handleDisconnectDialogSubmit}
        fieldId={currentItemId}
        onClose={() => setDisconnectDialogOpen(false)}
        onError={() => {
          enqueueSnackbar('Error disconnecting widget', {
            variant: 'error'
          });
        }}
        submitButtonLabel="Disconnect"
      />
      <ConfirmDialog
        title="Delete shopify widget"
        content="Do you want to disconnect and delete widget from Shopify?"
        actionUrl="/shopify/delete"
        open={deleteDialogOpen}
        onSubmit={handleDeleteDialogSubmit}
        fieldId={currentItemId}
        onClose={() => setDeleteDialogOpen(false)}
        onError={() => {
          enqueueSnackbar('Error deleting widget', {
            variant: 'error'
          });
        }}
        submitButtonLabel="Delete"
      />
      {(items.length !== 0) && (
        <>
          <Box>
            <Box
              sx={{
                pt: 3,
                pb: 3,
                display: 'flex',
              }}
            >
              <Typography
                variant="h2"
              >
                Shopify connections
              </Typography>
            </Box>
          </Box>
          <Card sx={{ mb: 3 }}>
            <PerfectScrollbar>
              <Box sx={{ minWidth: 1050 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        Widget name
                      </TableCell>
                      <TableCell>
                        Shop
                      </TableCell>
                      <TableCell>
                        Domain
                      </TableCell>
                      <TableCell />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {items.map((item) => (
                      <TableRow
                        hover
                        key={item.id}
                      >
                        <TableCell>
                          {item.widget.name}
                        </TableCell>
                        <TableCell>
                          {item.shop}
                        </TableCell>
                        <TableCell>
                          {item.widget.realDomains.map((domain) => (
                            <Typography
                              key={domain}
                              color="textPrimary"
                            >
                              {domain}
                            </Typography>
                          ))}
                        </TableCell>
                        <TableCell align="right">
                          {((item.connected === 1) && (
                            <Tooltip title="Disconnect">
                              <IconButton
                                size="medium"
                                color="primary"
                                variant="contained"
                                type="button"
                                onClick={() => handleDisconnect(item.id)}
                              >
                                <CodeOffIcon />
                              </IconButton>
                            </Tooltip>
                          )) || (
                            <Tooltip title="Connect">
                              <IconButton
                                size="medium"
                                color="primary"
                                variant="contained"
                                type="button"
                                onClick={() => handleConnect(item.id)}
                              >
                                <CodeIcon />
                              </IconButton>
                            </Tooltip>
                          )}
                          <Tooltip title="Delette">
                            <IconButton
                              size="medium"
                              color="secondary"
                              variant="contained"
                              type="button"
                              onClick={() => handleDelete(item.id)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </PerfectScrollbar>
          </Card>
        </>
      )}
    </>
  );
};

export default ShopifyList;
